import { addClassDuringActivity } from 'utilities/dom';
import { utagLinkPDP } from 'features/tealium';
import { setGenericEvent } from 'features/tealium/ga4/custom';

import dynamicImport from '../../../../features/webpack/dynamicImport.macro';

const { product_category: productCategory = [] } = window.utag_data;
const [ primaryCategory ] = productCategory;
function initShareProduct () {

	const trackPDPEvents = utagLinkPDP();
	const ui = {
		pdProdImg: document.querySelector('.pdProdImg'),
		pdEmailItem: document.querySelector('#pdEmailItem'),
		pdPrint: document.querySelector('#pdPrint'),
		pdQuickPrintContainer: document.querySelector('.pdQuickPrint'),
		pdQuickPrint: document.querySelector('#pdQuickPrint'),
		pdQuickPrintInput: document.querySelector('.pdQuickPrint input'),
		pdPinterest: document.querySelector('#pdPinterest')
	};

	const events = {
		showEmailAFriendItem (e) {

			e.preventDefault();

			const emailBtn = e.currentTarget;

			// this is needed for IE to prevent double-clicking
			if (emailBtn.classList.contains('noPointerEvents')) {

				return false;

			}

			const request = dynamicImport('desktop/product-email', '../email').then((module) => {

				const initEmailModal = module.default;
				return initEmailModal(window.patternSerial, window.shortSku, '');

			});

			addClassDuringActivity(emailBtn, 'noPointerEvents', request);

			trackPDPEvents({
				eventAction: 'Click-Email-Page',
				eventLabel: window.shortSku
			});
			setGenericEvent({
				event_name: 'pdp_email_click',
				pdp_item_id: window.shortSku,
				pdp_prime_cat: primaryCategory
			});

		},
		quickPrint (e) {

			e.preventDefault();

			const { pdProdImg, pdQuickPrintInput } = ui;
			const storeNumber = window.lp.globals.storeNumber === 0 ? 52 : window.lp.globals.storeNumber;

			let colorPattern = '000000';

			if (pdProdImg && pdProdImg.dataset.imgtype && pdProdImg.dataset.imgtype === 'artShade') {

				colorPattern = pdProdImg.dataset.patternColorCombination;

			}
			// TODO: Move shortSku from window global object.
			const { shortSku } = window;
			let source = `/popups/print-product.aspx?qpView=true&shortSku=${shortSku}&colorPattern=${colorPattern}`;

			trackPDPEvents({ eventAction: 'click-QP', eventLabel: `${shortSku}-${storeNumber}` });

			if (!window.lp.globals.isCustomerService && !window.lp.globals.isLoggedIn && pdQuickPrintInput) {

				const employeeEmailPrefix = pdQuickPrintInput.value.trim();
				if (employeeEmailPrefix.length < 3) {

					return false;

				}

				source += `&employeeEmailPrefix=${employeeEmailPrefix}`;

			}

			$(document.body).lpModal({
				onInit: true,
				width: 725,
				height: 250,
				src: source
			});
			return false;

		},
		print () {

			const { pdProdImg } = ui;
			let colorPattern;

			// if kiosk print then show options
			if (window.lp.globals.isKiosk || window.lp.globals.isCustomerService) {

				colorPattern = '000000';
				if (pdProdImg && pdProdImg.dataset.imgtype && pdProdImg.dataset.imgtype === 'artShade') {

					colorPattern = pdProdImg.dataset.PatternColorCombination;

				}

				$(document.body).lpModal({
					onInit: true,
					width: 725,
					height: 250,
					src: `/popups/print-product.aspx?shortSku=${window.shortSku}&colorPattern=${colorPattern}`
				});

			} else {

				// if not kiosk then print page
				window.print();

			}

			trackPDPEvents({
				eventAction: 'Click-Print',
				eventLabel: window.shortSku
			});
			setGenericEvent({
				event_name: 'pdp_print_click',
				pdp_item_id: window.shortSku,
				pdp_prime_cat: primaryCategory
			});

		},
		shareOnFaceBook (e) {

			e.preventDefault();

			const alternateLink = document.querySelector('link[rel=alternate]');
			const url = alternateLink && alternateLink.href ? alternateLink.href : window.location.href;
			if (window.FB) {

				window.FB.ui(
					{
						method: 'share',
						href: url
					},
					(response) => {}
				);

			}

		},
		pinIt (e) {

			e.preventDefault();

			const { pdProdImg } = ui;

			if (pdProdImg) {

				window.PinUtils.pinOne({
					media: pdProdImg.src
				});

			}
			setGenericEvent({
				event_name: 'pdp_pinterest_share',
				pdp_item_id: window.shortSku,
				pdp_prime_cat: primaryCategory
			});

		},
		quickPrintOnEnter (e) {

			const { pdQuickPrint } = ui;

			if (e.which === 13) {

				$(pdQuickPrint).trigger('click');

			}

		}
	};

	function init () {

		const {
			isCustomerService, isLoggedIn, showInvalidForCanada, showCallForAvailability
		} = window.lp.globals;

		const {
			pdEmailItem, pdPrint, pdQuickPrint, pdQuickPrintInput, pdQuickPrintContainer, pdPinterest
		} = ui;

		const {
			showEmailAFriendItem, print, quickPrint, quickPrintOnEnter, pinIt
		} = events;

		// Quick Print
		if (isCustomerService) {

			$(pdQuickPrintContainer).find('input').remove();

		} else if (isLoggedIn) {

			$(pdQuickPrintContainer).remove();

		}

		// chat - hide 1 chat button if both variables are true
		if (showInvalidForCanada && showCallForAvailability) {

			document.querySelector('.pdPleaseCall').classList.add('hidden');

		}

		if (window.isIpad()) {

			if (pdEmailItem) {

				pdEmailItem.addEventListener('touchstart', showEmailAFriendItem);

			}
			if (pdPrint) {

				pdPrint.addEventListener('click', print);

			}
			if (pdQuickPrint) {

				pdQuickPrint.addEventListener('touchstart', quickPrint);

			}

		} else {

			if (pdEmailItem) {

				pdEmailItem.addEventListener('click', showEmailAFriendItem);

			}
			if (pdPrint) {

				pdPrint.addEventListener('click', print);

			}
			if (pdQuickPrint) {

				pdQuickPrint.addEventListener('click', quickPrint);

			}

		}

		if (pdPinterest) {

			pdPinterest.addEventListener('click', pinIt);

		}
		if (pdQuickPrintInput) {

			pdQuickPrintInput.addEventListener('keypress', quickPrintOnEnter);

		}

	}

	return Object.freeze({ init });

}

export default initShareProduct;
